var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 11C13.2091 11 15 9.20914 15 7C15 4.79086 13.2091 3 11 3C8.79086 3 7 4.79086 7 7C7 9.20914 8.79086 11 11 11ZM16 7C16 8.86059 14.9837 10.4838 13.476 11.3449C17.2426 12.4204 20 15.8882 20 20H19H3H2C2 15.8882 4.75742 12.4204 8.52399 11.3449C7.01627 10.4838 6 8.86059 6 7C6 4.23858 8.23858 2 11 2C13.7614 2 16 4.23858 16 7ZM3.06189 19H18.9381C18.446 15.0537 15.0796 12 11 12C6.92038 12 3.55399 15.0537 3.06189 19Z",
    fill: "#252122"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.842fd0c43a94aafb8003dce47d421a50.svg";
export { ForwardRef as ReactComponent };